import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en/en.json';
import translationSV from './sv/sv.json';

const resources = {
  en: {
    translation: translationEN
  },
  sv: {
    translation: translationSV
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'sv',
  interpolation: {
    escapeValue: false
  }
});

export const setLanguageFromQueryParam = (lang: string | null) => {
  if (lang === 'en' || lang === 'sv') {
    i18n.changeLanguage(lang);
  } else {
    i18n.changeLanguage('sv');
  }
};

export default i18n;
